import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDatasource from './datasource.reducer';

export const selectDatasourceState = createFeatureSelector<fromDatasource.State>(fromDatasource.datasourceFeatureKey);

export const selectDatasources = createSelector(selectDatasourceState, (state) => state.datasources);
export const selectIsDatasourcesLoading = createSelector(selectDatasourceState, (state) => state.isDatasourcesLoading);
export const selectIsDatasourcesComplete = createSelector(
  selectDatasourceState,
  (state) => state.isDatasourcesComplete
);
export const datasourcesError = createSelector(selectDatasourceState, (state) => state.datasourcesError);

export const selectOrgDatasources = createSelector(selectDatasourceState, (state) =>
  state.datasources.filter((ds) => !ds.public)
);

export const selectReportDatasources = createSelector(selectDatasourceState, (state) => state.reportDatasources);
export const selectIsReportDatasourcesLoading = createSelector(
  selectDatasourceState,
  (state) => state.isReportDatasourcesLoading
);
export const selectIsReportDatasourcesComplete = createSelector(
  selectDatasourceState,
  (state) => state.isReportDatasourcesComplete
);
export const reportDatasourcesError = createSelector(selectDatasourceState, (state) => state.reportDatasourcesError);

const selectDatasourceUIEntity = createSelector(selectDatasourceState, (state) => state.reportDatasourcesUI);
export const { selectEntities: selectDatasourcesUI } =
  fromDatasource.datasourcesUIAdapter.getSelectors(selectDatasourceUIEntity);
